import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { SearchService } from '../../services/search/search.service';
import * as loginSelectors from '../../../root-store/login-store/login.selector';
import { Subscription, interval } from 'rxjs';
import { debounce } from 'rxjs/operators';
import { Store, select } from '@ngrx/store';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { EVENTS } from '@app/constants/events.constants';
import { relationshipStoreActions } from '@app/root-store';
import { UserConnectionService, UserService } from '@app/shared/services';
import { UserInviteComponent } from '../user-invite/user-invite.component';
import { UserInviteSuccessScreenComponent } from '@app/modules/relationship/components/dialogs/user-invite-success-screen/user-invite-success-screen.component';
import { SharedVaultService } from '@app/shared/services/vault/shared-vault.service';

import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'connect-user',
  templateUrl: './connect-user.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConnectUserComponent implements OnInit, OnDestroy {
  searchInput = '';
  userInput = new UntypedFormControl('');
  delay = 600;
  searchResults = [];
  search_val = '';
  subscription = new Subscription();
  currentUser = null;
  connection_relationship_data: any = {};
  selectedRelationship = {
    id: 68,
    name: 'Client',
  };
  isLoading = false;
  searchText = '';
  selectedUser: any = [];
  spouseList = ['Husband', 'Wife', 'Spouse', 'Fiancee', 'Civil Partner', 'Domestic Partner'];

  constructor(
    public dialogRef: MatDialogRef<ConnectUserComponent>,
    private searchService: SearchService,
    private cd: ChangeDetectorRef,
    private store: Store,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private modalService: NgbModal,
    private toastr: ToastrService,
    private _userService: UserService,
    private userConnectionService: UserConnectionService,
    private dialog: MatDialog,
    private sharedVaultService: SharedVaultService
  ) {
    this.selectedUser = data.selectedUser;
  }

  ngOnInit(): void {
    if (this.data?.fromNetworkRegister) {
      // this.selectedRelationship = {
      //   id: this.selectedUser?.relationship_id,
      //   name: this.selectedUser?.relationship_name,
      // };
    }
    this.subscription.add(
      this.store.pipe(select(loginSelectors.getCurrentUserFullDetails)).subscribe((result) => {
        if (result) {
          this.currentUser = result;
        }
        this.cd.detectChanges();
      })
    );

    this.subscription.add(
      this.userInput.valueChanges
        .pipe(
          debounce(() => {
            this.isLoading = true;
            return interval(this.delay);
          })
        )
        .subscribe((value) => {
          this.isLoading = true;
          if (value.trim() == '') {
            this.searchResults = [];
            this.search_val = '';
            this.isLoading = false;
            return;
          } else {
            this.isLoading = true;
            this.search_val = value;
            const payload = {
              search_type: 'all',
              search_val: value,
              user_id: this.currentUser.id,
            };
            this.subscription.add(
              this.searchService.search(payload).subscribe((res) => {
                // this.searchResults = res.filter(
                //   (user) => user.relationship_name.toLowerCase() == 'husband' || user.relationship_name.toLowerCase() == 'wife'
                // );
                const { data } = res;
                if (!!this.data) {
                  const { existingItems } = this.data;
                  if (!!existingItems || (this.data?.existingUsers && (this.data?.fromAddVault || this.data?.fromLinkedTemplate))) {
                    const isNotInArrayA =
                      !this.data?.fromAddVault && !this.data?.fromLinkedTemplate
                        ? (itemB) => !existingItems.some((item) => item.user_id === itemB.user_id)
                        : (itemB) => !this.data?.existingUsers.some((item) => item.user_id === itemB.user_id);
                    // Use filter with the condition function
                    const filtered = data.filter(isNotInArrayA);
                    const newList = filtered.filter((item) => {
                      if (!item.relationship_name) return item;
                    });
                    this.searchResults = newList;
                  } else {
                    this.searchResults = data;
                  }
                } else {
                  this.searchResults = data;
                }

                this.isLoading = false;
                this.cd.detectChanges();
              })
            );
          }
          this.isLoading = false;
        })
    );
  }
  closeDialog() {
    this.dialogRef.close();
  }
  clearSearch() {
    this.searchInput = '';
    this.search_val = '';
    this.searchResults = [];
    this.userInput.setValue('');
    this.cd.detectChanges();
  }
  handleRelationshipSearch(val) {
    this.searchText = val;
  }

  selectedRelationshipData;
  doSomething(selectedData) {
    selectedData.id ? (this.selectedRelationshipData = selectedData) : (this.selectedRelationshipData = null);
  }
  relationshipIdChanged(event) {
    return;
  }
  connectUser() {
    if (!this.selectedRelationshipData) return;
    const finaldata = {
      relationship_name: this.selectedRelationshipData.name,
      to_user_id: this.selectedUser?.id ?? this.selectedUser?.user_id,
      user_id: this.currentUser.id,
      requested_user_id: this.selectedUser?.id ?? this.selectedUser?.user_id,
      relationship_id: this.selectedRelationshipData.id,
    };
    // if (params?.user.user_type == UserTypeEnum.Professional && this.current_user['user_type'] != UserTypeEnum.Professional) {
    //   finaldata['relationship_id'] = ClientUserRelationship.id;
    //   finaldata['relationship_name'] = ClientUserRelationship.name;
    // }
    this.subscription.add(
      this.userConnectionService.connectToUser(finaldata).subscribe(
        (res) => {
          const data = {
            isexistingUser: true,
            success: true,
            ...finaldata,
            FullName: this.selectedUser.name,
          };
          this.subscription.add(this.userConnectionService.sendRelationshipRequestNotification(finaldata).subscribe());
          if (this.data?.requestForAddedUserData) {
            delete data.user_id;
            delete data.FullName;
            data['user_id'] = this.selectedUser.id;
            data['name'] = this.selectedUser.user_first_name + ' ' + this.selectedUser.user_last_name;
            data['user_profile_image_url'] = this.selectedUser?.user_profile_image_url;
          }
          const isSpouse = this.spouseList.includes(this.selectedRelationshipData.name);
          if (isSpouse) {
            this.createSharedVault(this.selectedUser);
          }
          if (this.data?.fromNetworkRegister) {
            this.toastr.success(`Request sent successfully`);
          }
          this.dialogRef.close(data);
          this.trackEventsInMixPanel();
          // } else {
          //   this.dialogRef.close();
          // }
        },
        (error) => {}
      )
    );
  }
  inviteUser() {
    this.userInput.setValue('');
    const modalRef3 = this.dialog.open(UserInviteComponent, {
      autoFocus: false,
      disableClose: true,
      panelClass: 'full-window-dialog-2',
    });
    this.subscription.add(
      modalRef3.afterClosed().subscribe(
        (res) => {
          if (res && res['success'] == true) {
            if (res['isexistingUser']) {
              this.toastr.success(`Connection request has been sent to ${res.FullName}`);
            } else {
              const modalRef = this.dialog.open(UserInviteSuccessScreenComponent, {
                autoFocus: false,
                panelClass: 'full-window-dialog-2',
                data: res,
              });
            }
          }
        },
        (error) => {}
      )
    );
  }

  // openInviteDialog() {
  //   this.modalService.open(UserInviteComponent);
  // }

  trackEventsInMixPanel() {
    const events =
      this.data?.type === 'Immediate Family Members'
        ? [{ eventName: EVENTS.network_setup_immediate_family_add_change }]
        : this.data?.type === 'In-Laws'
        ? [{ eventName: EVENTS.network_setup_in_laws_add_change }]
        : this.data?.type === 'Extended Family Members'
        ? [{ eventName: EVENTS.network_setup_extended_family_add_change }]
        : this.data?.type === 'Other Relationships'
        ? [{ eventName: EVENTS.network_setup_other_relationship_add_change }]
        : this.data?.type === 'Service Providers'
        ? [{ eventName: EVENTS.network_setup_service_providers_add_change }]
        : this.data?.type === 'Staff'
        ? [{ eventName: EVENTS.network_setup_staff_add_change }]
        : [];
    this._userService.trackEventsInMixPanel(events).then((response) => {});
  }
  clearUser() {
    this.selectedUser = null;
    this.searchInput = '';
    this.search_val = '';
    this.userInput.setValue('');
    this.dialogRef.close();
  }
  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
    this._userService.cleanupWorker();
  }
  createSharedVault(member) {
    const members = {
      name: member?.nick_name ?? member?.user_first_name,
      user_id: member?.id as any,
      type: 'member' as 'member',
    };
    const payload = {
      user_id: this.currentUser.id as any,
      name: `${this.currentUser?.nick_name ?? this.currentUser.first_name}`,
      member: [members],
    };
    this.subscription.add(this.sharedVaultService.createSharedVault(payload).subscribe(() => {}));
  }
}
